import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { RefreshCw, Sparkles } from 'lucide-react';

const messages = [
  "You're doing amazing! Your journey is uniquely yours 💫",
  "Take a deep breath. You've got this! ✨",
  "Every small step forward is progress worth celebrating 🌟",
  "You are stronger than you know, braver than you believe 💪",
  "It's okay to take things one day at a time 🌱",
  "Your feelings are valid. You matter! 💖",
  "Remember to be gentle with yourself today 🌸",
  "You're making progress, even if you can't see it yet ⭐",
  "Your presence makes the world a better place 🌍",
  "It's okay to rest. You deserve it! 🌙",
  "You're exactly where you need to be right now 🎯",
  "Your potential is limitless. Dream big! 🚀",
  "You bring unique gifts to the world 🎁",
  "Your strength inspires others 💫",
  "Today is a new beginning. Make it yours! ✨"
];

export function ComfortingMessages() {
  const [currentMessage, setCurrentMessage] = useState(() => 
    messages[Math.floor(Math.random() * messages.length)]
  );
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refreshMessage = () => {
    if (isRefreshing) return;
    
    setIsRefreshing(true);
    const newMessage = messages[Math.floor(Math.random() * messages.length)];
    
    // Ensure we don't get the same message twice
    if (newMessage === currentMessage) {
      refreshMessage();
      return;
    }
    
    setCurrentMessage(newMessage);
    setTimeout(() => setIsRefreshing(false), 500);
  };

  useEffect(() => {
    const interval = setInterval(refreshMessage, 30000); // Auto refresh every 30 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="theme-card p-6 relative overflow-hidden backdrop-blur-xl border-primary/20">
      {/* Metaverse-inspired Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-purple-500/5 to-blue-500/5 animate-pulse" />
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-primary/20 to-purple-500/20 blur-3xl rounded-full animate-pulse" />
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-blue-500/20 to-purple-500/20 blur-2xl rounded-full animate-pulse" />
      </div>

      {/* Content */}
      <div className="relative">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className="relative">
              <Sparkles className="w-5 h-5 text-primary animate-pulse" />
              <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
            </div>
            <h3 className="text-lg font-semibold bg-gradient-to-r from-primary to-purple-400 bg-clip-text text-transparent">
              Daily Affirmation
            </h3>
          </div>
          <motion.button
            onClick={refreshMessage}
            disabled={isRefreshing}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="p-2 rounded-lg hover:bg-primary/10 transition-colors relative group"
          >
            <RefreshCw className={`w-4 h-4 text-primary transition-transform ${
              isRefreshing ? 'animate-spin' : ''
            }`} />
            <div className="absolute inset-0 bg-primary/20 rounded-lg blur-xl opacity-0 group-hover:opacity-100 transition-opacity" />
          </motion.button>
        </div>

        <motion.div
          key={currentMessage}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="bg-primary/10 backdrop-blur-sm rounded-lg p-4 text-center relative overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-purple-500/5 to-blue-500/5 animate-pulse" />
          <p className="relative text-lg font-medium bg-gradient-to-r from-primary via-purple-400 to-blue-400 bg-clip-text text-transparent">
            {currentMessage}
          </p>
        </motion.div>
      </div>
    </div>
  );
}